'use strict';

angular.module('licensure.services')
    .factory('ViewedLicenses', ['$http', '$q', function ($http, $q) {
    	return {
    		save: function (license_id) {
    			var d = $q.defer();

    			var method = 'POST';
    			var url = apiLocation + '/api/viewedlicenses/';

    			$http({
    				method: method,
    				url: url,
    				data: {
    					license_id: license_id
    				}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

    			return d.promise;
    		}
    	}
    }])
;